import MyEventBus from "@/utils/MyEventBus";

export const EventBus = new MyEventBus();
